import { IconProps } from "../../../types/style";

const ArrowUpFillSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M22.5 7.81V16.18C22.5 19.82 20.33 21.99 16.69 21.99H8.31C4.67 22 2.5 19.83 2.5 16.19V7.81C2.5 4.17 4.67 2 8.31 2H16.68C20.33 2 22.5 4.17 22.5 7.81Z"
          fill={color}
        />
        <path
          d="M13.03 5.47L17.32 9.76C17.61 10.05 17.61 10.53 17.32 10.82C17.03 11.11 16.55 11.11 16.26 10.82L13.25 7.81V18C13.25 18.41 12.91 18.75 12.5 18.75C12.09 18.75 11.75 18.41 11.75 18V7.81L8.73996 10.82C8.44996 11.11 7.96996 11.11 7.67996 10.82C7.52996 10.67 7.45996 10.48 7.45996 10.29C7.45996 10.1 7.53996 9.9 7.67996 9.76L11.97 5.47C12.11 5.33 12.3 5.25 12.5 5.25C12.7 5.25 12.89 5.33 13.03 5.47Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ArrowUpFillSVG;
